import { getTemplateOrDefault } from '../utils/index.js';
import requiredRule from '../defaultTemplates/requiredRules.js';
import optionalRule from '../defaultTemplates/optionalRules.js';

var retrieveRulePromptTitle = function retrieveRulePromptTitle(_ref) {
  var ruleTemplates = _ref.ruleTemplates,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.title');
  }
  return templateString;
};
var retrieveRulePromptSubtitle = function retrieveRulePromptSubtitle(_ref2) {
  var ruleTemplates = _ref2.ruleTemplates,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.subtitle');
  }
  return templateString;
};
var retrieveRulePromptDescription = function retrieveRulePromptDescription(_ref3) {
  var ruleTemplates = _ref3.ruleTemplates,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.description');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.description');
  }
  return templateString;
};
var retrieveRuleMenuTitle = function retrieveRuleMenuTitle(_ref4) {
  var ruleTemplates = _ref4.ruleTemplates,
    _ref4$required = _ref4.required,
    required = _ref4$required === void 0 ? false : _ref4$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.title');
  }
  return templateString;
};
var retrieveRuleMenuSubtitle = function retrieveRuleMenuSubtitle(_ref5) {
  var ruleTemplates = _ref5.ruleTemplates,
    _ref5$required = _ref5.required,
    required = _ref5$required === void 0 ? false : _ref5$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.subtitle');
  }
  return templateString;
};
var retrieveRuleMenuAction = function retrieveRuleMenuAction(_ref6) {
  var ruleTemplates = _ref6.ruleTemplates,
    _ref6$required = _ref6.required,
    required = _ref6$required === void 0 ? false : _ref6$required;
  var templateString = '';
  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.button');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.button');
  }
  return templateString;
};
var getHeaderDescription = function getHeaderDescription(loader) {
  switch (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.type && loader.pricing.monetization.type) {
    case 'pass':
      return 'Already a pass holder?';
    case 'donation':
      return 'Already a donor?';
    case 'subscription':
      if (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.is_pledge) {
        return 'Already a member?';
      }
      return 'Already a subscriber?';
    case 'group':
      return 'Already have an account?';
    default:
      return 'Already have an account?';
  }
};

export { getHeaderDescription, retrieveRuleMenuAction, retrieveRuleMenuSubtitle, retrieveRuleMenuTitle, retrieveRulePromptDescription, retrieveRulePromptSubtitle, retrieveRulePromptTitle };
//# sourceMappingURL=ruleTemplate.js.map
